import React from 'react';
import AddControl_Row from '../AddControlRow';
import { DropDownControlCodeTableObject, IProps } from './DropDownControlCodeTableObject';

interface IProp extends IProps {
  label: string;
}

function DropDownControlCodeTableRow(props: IProp) {
  const component = (
    <DropDownControlCodeTableObject
      {...props}
      validationMessage={props.validationMessage ? props.validationMessage : `Value for "${props.label}" is required`}
    />
  );
  return (
    <AddControl_Row
      component={component}
      description={props.label}
      isReadOnly={props.isReadonly ? props.isReadonly : false}
      isRequired={props.isRequired ? props.isRequired : false}
    />
  );
}

export default DropDownControlCodeTableRow;
